<template>
  <!--   2-3 点击忘记密码邮件链接，跳转回网站时的着落页面 -->
  <!-- 登录的操作部分 -->
  <div class="login-main">
    <div class="index-top">
      <!-- 左侧logo语言切换 -->
      <div class="logo">
        <div><img src="./assets/Logo Shapes 42.png" alt="" /></div>
        <p class="logo-title">{{ $t("easyCareer") }}</p>
        <!-- 语言切换 -->
      </div>
    </div>
    <div class="login-main-box" v-if="!maskIsShow">
      <div class="box-top">
      </div>
      <div class="bottom-box">
        <div class="bottom-box-title">
          <p class="welcom">Welcome Back!</p>
          <p class="ja-welcom">
            <span>{{ $t("resetPassword") }}</span>
            <el-dropdown class="lang-dropdown" @command="handleCommand">
              <span class="el-dropdown-link">
                {{ lang }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="0">{{ $t("chinese") }}</el-dropdown-item>
                <el-dropdown-item command="1">{{ $t("japanese") }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </p>
        </div>
        <div class="box-form">
          <!-- 显示用户已经设定的邮件地址，这里不可编辑 -->
          <div class="emil-input">
            <p class="emil-input-title">
              {{ $t("emil") }}
              <span v-if="emilShow" class="emil-true-css">{{ $t('emilError') }}</span>
            </p>
            <div class="emil-input-css">
              <img src="./assets/Vector (1).png" alt="" class="emil-icon" />
              <input type="text" :disabled="true" class="emil-input-css-main" v-model="emilInfo"
                style="background: #FAFAFA;" />
            </div>
          </div>
        </div>
        <!-- 新密码input -->
        <div class="emil-input">
          <p class="emil-input-title">{{ $t("newPassword") }}</p>
          <div class="emil-input-css">
            <img src="./assets/Vector.png" alt="" class="emil-icon" />
            <input type="password" class="emil-input-css-main" v-model="passwordData1" style="background: #FAFAFA;" />
          </div>
        </div>
        <!-- 确认密码 -->
        <div class="emil-input">
          <p class="emil-input-title">{{ $t("enterPasswordAgain") }}</p>
          <div class="emil-input-css">
            <img src="./assets/Vector.png" alt="" class="emil-icon" />
            <input type="password" class="emil-input-css-main" v-model="passwordData2" style="background: #FAFAFA;" />
          </div>
        </div>
        <!-- 确定按钮 -->
        <div class="insure">
          <button class="insure-button" @click="goToLogin">
            {{ $t("resetPassword") }}
          </button>
        </div>
      </div>
    </div>
    <div class="mask-div" v-if="maskIsShow">
      <i class="el-icon-loading"></i>
    </div>
  </div>
</template>

<script>
import { resetPassword, userResetPassword, checkToken } from "../../js/api";
import jwtDecode from "jwt-decode";

export default {
  name: "index",
  data() {
    return {
      emilData: "", //登录页面邮箱input
      passwordData1: "", //输入新密码
      passwordData2: "", //再输入一次
      emilShow: false, //邮箱正则校验
      lang: "JP", //语言
      token: "",
      maskIsShow: true,
      userInfo: {},
      emilInfo:""
    };
  },
  created() {
    console.log("---------------url参数---------------")
    console.log(window.location.href)
    var urlToken = window.location.href
    var urlString = urlToken.split("token=")
    this.token = urlString[1]
    console.log("测试是否能有效的获取到token")
    console.log(this.token)
    this.checkToken();
  },
  methods: {

    //切换语言
    handleCommand(command) {
      if (command === "0") {
        this.$i18n.locale = "zh-CN";
        this.lang = "CN";
      } else {
        this.$i18n.locale = "ja-JP";
        this.lang = "JP";
      }
    },
    //找回密码token校验
    checkToken() {
      var fakeInfo = {
        token: this.token
      }
      checkToken(fakeInfo).then((res) => {
        console.log("--------找回密码token校验接口数据--------");
        console.log(res)
        if (res.data.code === "A0000") {
          const code = jwtDecode(this.token)
          console.log(code)
          this.emilInfo = code.emailAddress
          this.userInfo = code
          this.maskIsShow = false
          this.$message({
            message: '验证成功',
            type: 'success'
          });
        } else if (res.data.code === "A0440") {
          this.$message({
            message: '验证超时',
            type: 'warning'
          });
        } else if (res.data.code === "C0231") {
          this.$message.error('连接失败请重新操作');
        }
      }).catch((res) => {
        console.log("找回密码token校验数据异常:", res)
      })
    },

    //重置密码
    goToLogin() {
      if (this.passwordData1 !== this.passwordData2) {
        this.$message({
          message: '两次密码输入不一致',
          type: 'warning'
        });
      } else {
        var fakeInfo = {
          password: this.passwordData1,
          token: this.token
        }
        userResetPassword(fakeInfo).then((res) => {
          console.log("--------重置密码接口数据--------");
          console.log(res)
          if (res.data.data = "A0000") {
            this.$message({
              message: '重置密码成功',
              type: 'success'
            });
            this.$router.push("/login");
          } else if (res.data.data = "A0161") {
            this.$message({
              message: '链接已过期',
              type: 'warning'
            });
          } else if (res.data.data = "A0404") {
            this.$message({
              message: '邮箱不存在',
              type: 'warning'
            });
          } else {
            this.$message.error('重置密码失败');
          }

        }).catch((res) => {
          console.log("重置密码数据异常:", res)
        })
      }

    }
  }
}
</script>

<style scoped>
.emil-true-css {
  margin-left: 10px;
  color: #f56c6c;
  width: 220px;
  text-align: right;
  display: inline-block;
}

.login {
  width: 100vw;
  height: 100vh;
  background: #51abff;
  display: flex;
  position: relative;
}

.forget-password {
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.mask-div {
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  position: absolute;
  top: 0;
  left: 0;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 40px;
}

.password-dialog {
  width: 498px;
  height: 266px;
  background: #ffffff;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  padding: 15px;
  box-sizing: border-box;
}

.dialog-title {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 34px;
  color: #686868;
}

.dialog-hint {
  margin-left: 17px;
  width: 434px;
  height: 48px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #686868;
  margin-top: 13px;
}

.dialog-emil-input {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  height: 60px;
}

.dialog-emil-button {
  width: 118px;
  height: 24px;
  line-height: 24px;
  background: #ffffff;
  border: 1px solid #51abff;
  box-sizing: border-box;
  border-radius: 4px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  cursor: pointer;
  color: #51abff;
}

.dialog-emil-hint {
  margin-top: 5px;
  text-align: right;
  padding-right: 15px;
  box-sizing: border-box;
  color: #f56c6c;
}

.dialog-button-css {
  text-align: center;
  margin-top: 20px;
}

.login-logo {
  height: 100vh;
  width: 50vw;
  padding: 250px 0 0 110px;
  box-sizing: border-box;
}

.logo-title {
  font-family: "Mochiy Pop P One";
  font-style: normal;
  font-weight: 400;
  font-size: 96px;
  line-height: 139px;
  color: #ffffff;
  margin-top: -25px;
}

.logo-title-intro {
  width: 312px;
  height: 176px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 40px;
  color: #ffffff;
  margin-top: 36px;
}

.login-main {
  background: #fff;
  width: 100vw;
  height: 100vh;
  position: relative;
}

.login-main-box {
  width: 404px;
  height: 550px;
  background: #FAFAFA;
  border: 2px solid #ececec;
  box-sizing: border-box;
  border-radius: 8px;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -202px;
  margin-top: -275px;
}

.box-top {
  height: 50px;
  line-height: 50px;
  width: 100%;
}

.top-icon {
  width: 50px;
  height: 50px;
  float: right;
  text-align: center;
  cursor: pointer;
}

.bottom-box {
  height: 438px;
  padding: 0 40px;
  box-sizing: border-box;
}

.bottom-box-title {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 324px;
  height: 56px;
}

.welcom {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  align-items: center;
  text-align: center;
  color: #98989e;
  margin: 3px 0px;
}

.ja-welcom {
  width: 100%;
  height: 32px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  color: #212429;
  display: flex;
}

.lang-dropdown {
  margin-left: 10px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 13.6333px;
  line-height: 16px;
  letter-spacing: 0.639063px;
  color: #686868;
  padding-top: 12px;
  box-sizing: border-box;
}

.el-dropdown-link {
  cursor: pointer;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.box-form {
  margin-top: 40px;
}

.emil-input {
  padding: 0px;
  width: 324px;
  height: 66px;
  margin-bottom: 10px;
}

.emil-input-title {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  color: #686868;
  margin: 8px 0px;
}

.emil-input-css {
  border: 1px solid #d8d8d8;
  box-sizing: border-box;
  border-radius: 24px;
  height: 40px;
  width: 320px;
  box-sizing: border-box;
}

.code-input-css {
  border: 1px solid #d8d8d8;
  box-sizing: border-box;
  border-radius: 24px;
  height: 40px;
  width: 180px;
  box-sizing: border-box;
}

.code-main-css-flex {
  display: flex;
}

.code-img-main {
  background: paleturquoise;
  width: 100px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  margin-left: 25px;
}

.emil-icon {
  margin-right: 10px;
  margin-left: 15px;
}

.emil-input-css-main {
  width: 250px;
  height: 38px;
  line-height: 38px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  color: #c9cfda;
}

.code-input-css-main {
  width: 110px;
  height: 38px;
  line-height: 38px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  color: #c9cfda;
}

.forget {
  overflow: hidden;
}

.index-top {
  padding: 16px 35px;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
}

.logo {
  width: 250px;
  display: flex;
}

.logo-title {
  font-family: "Mochiy Pop One";
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 35px;
  text-align: center;
  letter-spacing: -0.02em;
  color: #686868;
  margin: 0 5px;
}

.forget-main {
  width: 120px;
  float: right;
  text-align: right;
  font-family: "Work Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 15px;
  letter-spacing: -0.02em;
  color: #51abff;
  cursor: pointer;
}

.insure {
  height: 50px;
  margin-top: 50px;
  margin-bottom: 10px;
}

.insure-button {
  background: #fc630c;
  border-radius: 24px;
  font-family: "Work Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 23px;
  text-align: center;
  letter-spacing: -0.02em;
  color: #ffffff;
  width: 320px;
  height: 50px;
  cursor: pointer;
}

.new-goto {
  text-align: center;
  font-family: "Work Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 15px;
  letter-spacing: -0.02em;
  color: #c9cfda;
  width: 320px;
}

.register {
  cursor: pointer;
  color: #51abff;
}
</style>



// WEBPACK FOOTER //
// src/pages/forgetPasswordEmailLink/index.vue